var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidElementType } from 'react-is';
import { SolarAppBar, SolarLayout, SolarMenu, } from '@react-admin/ra-navigation';
import { Breadcrumb as DefaultBreadcrumb } from './Breadcrumb';
import { LayoutWrapper } from './LayoutWrapper';
/**
 * A <Layout> component for ra-enterprise which pre-configures the enterprise modules.
 *
 * What is pre-configured?
 * - A breadcrumb on every pages based on the resources (from @react-admin/ra-navigation)
 * - An AppLocationContext, to allow the use of @react-admin/ra-navigation features.
 *
 * It uses the same API as the <Layout> component from react-admin,
 * and add new props based on the enterprise edition.
 *
 * @param {object} appBar The customized <AppBar>. Default to the @react-admin/ra-navigation <SolarAppBar>.
 * @param {object} breadcrumb The customized <Breadcrumb>. Default to the @react-admin/ra-enterprise <Breadcrumb>.
 * @param {object} menu The customized <Menu>. Default to the @react-admin/ra-navigation <SolarMenu>.
 *
 * @example Customize the <Layout> main elements (the <AppBar>, the <Breadcrumb> and the <Menu>)
 *
 * import { Breadcrumb, SolarAppBar, SolarMenu } from '@react-admin/ra-navigation';
 * import { Admin, Layout } from '@react-admin/ra-enterprise';
 *
 * const CustomAppBar = () => (
 *     <SolarAppBar>
 *          // You custom SolarAppBar.
 *          // See @react-admin/ra-navigation for more details about SolarAppBar.
 *     </SolarAppBar>
 * );
 *
 * const CustomMenu = () => (
 *     <SolarMenu>
 *          // You custom SolarMenu.
 *          // See @react-admin/ra-navigation for more details about SolarMenu.
 *     </SolarMenu>
 * );
 *
 * const CustomBreadcrumb = () => (
 *     <Breadcrumb>
 *         // You custom beadcrumb.
 *         // See @react-admin/ra-navigation for more details about breadcrumbs.
 *     </Breadcrumb>
 * );
 *
 * const CustomLayout = ({ children }) => (
 *     <Layout
 *         appBar={CustomAppBar}
 *         breadcrumb={CustomBreadcrumb}
 *         menu={CustomMenu}
 *     >
 *        {children}
 *    </Layout
 * );
 *
 * const dataProvider = {
 *     // Connect to your API
 * };
 *
 * const App = () => (
 *     <Admin dataProvider={dataProvider} layout={CustomLayout}>
 *         // Put your resources here
 *     </Admin>
 * );
 */
export var Layout = function (props) {
    var _a = props.appBar, AppBar = _a === void 0 ? SolarAppBar : _a, _b = props.breadcrumb, Breadcrumb = _b === void 0 ? DefaultBreadcrumb : _b, _c = props.menu, Menu = _c === void 0 ? SolarMenu : _c, rest = __rest(props, ["appBar", "breadcrumb", "menu"]);
    return (_jsx(LayoutWrapper, { children: _jsx(SolarLayout, __assign({ appBar: AppBar, menu: Menu }, rest, { children: _jsxs(_Fragment, { children: [isValidElementType(Breadcrumb) ? (_jsx(Breadcrumb, {})) : (Breadcrumb), props.children] }) })) }));
};
